var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_vm._l((_vm.channels),function(channel){return [_c('v-col',{key:channel.uuid,attrs:{"cols":"4"}},[_c('ChannelCard',{attrs:{"channel":channel}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }